import { ReactNode } from "react";
import { Card, marketLogoSize, PulseCard, tokenLogoSize } from "./market-card";
import { tv } from "tailwind-variants";

export const container = tv({
  base: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2.5",
});

export const MarketCards = {
  Card,
  Container,
  container,
  marketLogoSize,
  tokenLogoSize,
  PulseCard,
};

interface ContainerProps {
  className?: string;
  children?: ReactNode;
}

function Container({ className, children }: ContainerProps): JSX.Element {
  return <div className={container({ className })}>{children}</div>;
}
